import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { about, home } from "../mock";
import Reveal from "../components/Reveal";
import { BrandCard } from "./Home";

export default function About() {
  return (
    <div>
      {/* HERO — full-width static mirrorball-as-moon, copy on the darker (right) side */}
      <section className="relative min-h-[92vh] flex items-stretch overflow-hidden bg-[#050505]">
        <img
          src={about.hero.bg}
          alt="A mirrorball hanging like a moon over a dark, quiet landscape"
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* darken the right side so overlaid copy stays legible */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#0a0908]/40 to-[#0a0908]/92" />
        {/* extra flat darkening on small screens */}
        <div className="absolute inset-0 bg-[#0a0908]/55 md:bg-transparent" />
        <div className="grain" />

        {/* copy overlaid on the darker right side */}
        <div className="container-x relative z-10 w-full flex items-end md:items-center justify-end pb-16 md:pb-0 pt-64 md:pt-0">
          <div className="w-full md:w-1/2 lg:w-[42%] md:ml-auto">
            <Reveal><p className="eyebrow mb-5">{about.hero.eyebrow}</p></Reveal>
            <Reveal delay={80}>
              <h1 className="font-display uppercase font-bold text-4xl md:text-6xl text-white leading-none">
                {about.hero.title}
              </h1>
            </Reveal>
            <Reveal delay={150}>
              <p className="font-serif-accent italic text-xl md:text-2xl text-gold mt-5">
                {about.hero.subtitle}
              </p>
            </Reveal>
            <Reveal delay={220}>
              <p className="font-body text-white/70 mt-6 text-base md:text-lg leading-relaxed font-light">
                {about.lead}
              </p>
            </Reveal>
          </div>
        </div>
      </section>
      <div className="gold-rule" />

      {/* TIMELINE BLOCKS */}
      <section className="section-pad bg-[#0c0b08]">
        <div className="container-x max-w-4xl">
          <div className="space-y-14">
            {about.blocks.map((blk, i) => (
              <Reveal key={blk.year} delay={i * 80}>
                <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-4 md:gap-10 items-start border-l border-border pl-6 md:pl-0 md:border-l-0">
                  <h3 className="font-display uppercase tracking-wide text-gold text-xl md:text-2xl md:text-right">
                    {blk.year}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed md:border-l md:border-border md:pl-10">
                    {blk.body}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* BRAND TILES — same flipping tiles as the Home page, sitting on a photo */}
      <section className="relative section-pad border-y border-border overflow-hidden">
        <div
          className="absolute inset-0 bg-center bg-cover bw"
          style={{ backgroundImage: "url(/assets/melano/photos/p74.webp)" }}
        />
        <div className="absolute inset-0 bg-[#0a0908]/82" />
        <div className="grain" />
        <div className="container-x relative z-10">
          <Reveal>
            <p className="eyebrow text-center mb-4">The ways we bring it to life</p>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-display uppercase font-bold text-3xl md:text-5xl text-white text-center mb-12">
              Our Brands
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {home.ecosystem.brands.map((b, i) => (
              <Reveal key={b.id} delay={i * 120}><BrandCard brand={b} /></Reveal>
            ))}
          </div>
          <Reveal delay={200}>
            <p className="text-center text-white/40 text-xs uppercase tracking-[0.2em] font-display mt-10">
              Tap a tile to reveal
            </p>
          </Reveal>
        </div>
      </section>

      {/* ENQUIRIES */}
      <section className="section-pad hero-atmosphere relative overflow-hidden">
        <div className="grain" />
        <div className="container-x max-w-2xl text-center relative z-10">
          <Reveal>
            <p className="font-serif-accent italic text-2xl md:text-3xl text-foreground leading-relaxed">
              {about.enquiries}
            </p>
          </Reveal>
          <Reveal delay={120}>
            <Link
              to="/contact"
              className="gold-lift mt-10 inline-flex items-center gap-2 bg-melano-purple text-white font-display uppercase font-bold tracking-[0.18em] text-sm px-9 py-4 rounded-sm hover:brightness-110 transition"
            >
              Get in touch <ArrowRight size={16} />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
